<template>
  <v-menu
    open-on-hover
    min-width="300px"
    v-if="oferta.promocao.ativo"
    v-model="opened"
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on }">
      <v-icon small color="secondary" v-on="on">
        mdi-sale
      </v-icon>
    </template>
    <v-card class="mx-auto"
            max-width="400">
      <v-card-title>
        Promoção ativa
      </v-card-title>
      <v-card-text class="text--primary">
        <v-row>
          <v-col cols="12">
            <span class="caption font-weight-bold">
              Percentual de desconto
            </span>
            <div>
              {{ oferta.promocao.percentualDesconto * 100 | number('0.00') }}%&nbsp;
            </div>
          </v-col>
          <v-col cols="12">
            <span class="caption font-weight-bold">
              Data inicio
            </span>
            <div>
              {{ oferta.promocao.dataInicio | date | naoInformado }}
            </div>
          </v-col>
          <v-col cols="12">
            <span class="caption font-weight-bold">
              Data limite
            </span>
            <div>
              {{ oferta.promocao.dataLimite | date | naoInformado }}
            </div>
          </v-col>
          <v-col cols="12">
            <span class="caption font-weight-bold">
               Preço de à vista no prazo
            </span>
            <div>
              <px-boolean-sim-nao :value="oferta.promocao.igualarPreco"/>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  props: {
    oferta: Object,
  },
  data() {
    return {
      opened: false,
    };
  },
};
</script>
